import { Stack } from '@pubstack/common/src/stack'
import { FunctionComponent } from 'react'
import { Colors } from '~/assets/style/colors'
import { Icon } from '~/components/Icon'
import { Tooltip } from '~/components/Tooltip'

type Props = {
  /** Only what the status is read from, so a rule's usage of a stack shows it the same way the stack list does. */
  stack: Pick<Stack, 'status' | 'isOutOfSync'>
}

export const StackStatus: FunctionComponent<Props> = ({ stack }) => {
  const iconName = stack.isOutOfSync ? 'sync_problem' : stack.status === 'live' ? 'check_circled' : stack.status === 'archived_group' ? 'folder' : stack.status === 'to-deploy' ? 'send' : null
  const iconFill = stack.isOutOfSync ? Colors.Warning : ['to-deploy', 'live'].includes(stack.status) ? Colors.Success : stack.status === 'archived_group' ? Colors.SlateGrey : undefined
  const label = stack.status === 'to-deploy' ? 'Ready to deploy' : stack.status === 'archived_group' ? 'Archived' : stack.status === 'live' ? 'Live' : ''
  return (
    <div className={'flex items-center gap-1'}>
      {iconName &&
        (stack.isOutOfSync ? (
          <Tooltip title="Synchronization required" className={'h-[18px]'}>
            <Icon name={iconName} fill={iconFill} height="18px" width="18px" />
          </Tooltip>
        ) : (
          <Icon name={iconName} fill={iconFill} height="18px" width="18px" />
        ))}
      {label}
    </div>
  )
}
